import {
  createFileRoute,
  notFound,
  redirect,
  type RedirectOptions,
} from "@tanstack/react-router";

type RoutePath = RedirectOptions["to"];

/* 
  Redirects here adds backwards compatibility for old links so that old links still work.
*/
const redirectsMap: Record<string, RoutePath> = {
  "/flightsExternal": "/flights/external",
  "/hotelsExternal": "/hotels/external",
};

export const Route = createFileRoute("/$")({
  beforeLoad: ({ location }) => {
    const destination = redirectsMap[location.pathname];

    if (destination) {
      throw redirect({
        to: destination,
        search: location.search,
        replace: true,
      });
    }

    throw notFound();
  },
});
